import { TFunction } from 'i18next';

export const getMonths = (t: TFunction) => [
  { value: '01', label: t('month-jan') },
  { value: '02', label: t('month-feb') },
  { value: '03', label: t('month-mar') },
  { value: '04', label: t('month-apr') },
  { value: '05', label: t('month-may') },
  { value: '06', label: t('month-jun') },
  { value: '07', label: t('month-jul') },
  { value: '08', label: t('month-aug') },
  { value: '09', label: t('month-sep') },
  { value: '10', label: t('month-oct') },
  { value: '11', label: t('month-nov') },
  { value: '12', label: t('month-dec') },
];

export const getDays = () => {
  return Array.from({ length: 31 }, (_, i) => {
    const day = i + 1;
    return {
      value: day.toString().padStart(2, '0'),
      label: day.toString().padStart(2, '0'),
    };
  });
};

export const getYears = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 100 }, (_, i) => {
    const year = currentYear - i - 17;
    return { value: year.toString(), label: year.toString() };
  });
};
